import { DefaultButton, PrimaryButton, TooltipHost } from "@fluentui/react";
import { useTranslation } from "react-i18next";
import "./UserColumn.css"
import { getAllFirmName } from "./Supervisor";
import CustomToolTipHost from "../../components/CustomToolTipHost/CustomToolTipHost";
import { useContext } from "react";
import userContext from "../../context/users/UserContext";
import { USERTYPES } from "../Constants";
import { getEnv } from "../../helpers/EnvHelper";
export const FirmDoctorColumns = (userId, handleActionButton, handleUserClick, handleLockButton,openPasswordReset,isResetDisabled) => {

    const {t} = useTranslation();
    const childTrPadding = (getEnv("REACT_APP_HYBRID_MODE") == "false") ? "15px 0px 15px 10px" : "15px 10px";
    const{resetPasswordAllowed}=useContext(userContext);
    const {roles}=useContext(userContext);
    return [
      {
        id: "username",
        style: { width: "20%", boxSizing:'border-box', padding:"0px 10px" },
        headerStyle: {padding:"15px 0px 15px 10px", textAlign: "left", width: "20%", boxSizing:'border-box'},
        headerClass:"break-word",
        classChildName:
            "break-word cursor-pointer",
        header: () => (
          <span className="">Details</span>
        ),
        accessor: "clients",
        accessorKey: "clients",
        show: true,
        cell: (info) =>  <>
        <div>
            <div className="user-heading">{t("user.username")}</div>
            <div className="user-sub-heading">{info.row.original.username}</div>
        </div>

        <div className="user-mt-10">
            <div className="user-heading">Full Name</div>
            <div className="user-sub-heading">{info.row.original.firstName}{" "}{info.row.original.lastName}</div>
        </div>
      </>,
      },
      {
        id: "email",
        style: { width: "24%", boxSizing:'border-box', padding:"0px 10px" },
        headerStyle: {padding:childTrPadding, textAlign: "left", width: "24%", boxSizing:'border-box'},
        headerClass:"break-word",
        classChildName:
            "break-word cursor-pointer",
        header: () => (
          <span className="">Contact Details</span>
        ),
        accessor: "email",
        accessorKey: "email",
        show: true,
        cell: (info) =>  <>
        <div>
            <div className="user-heading">{t("user.email")}</div>
            <div className="user-sub-heading">{info.row.original.email}</div>
        </div>

        <div className="user-mt-10">
            <div className="user-heading">{t("user.mobile")}</div>
            <div className="user-sub-heading">{info.row.original.mobile}</div>
        </div>

    </>,
      },
      {
        id: "firm-access",
        style: { width: "22%", boxSizing:'border-box', padding:"0px 10px" },
        headerStyle: {padding:"15px 0px 15px 10px", textAlign: "left", width: "22%", boxSizing:'border-box'},
        headerClass:"break-word",
        classChildName:
            "break-word cursor-pointer",
        header: () => (
          <span className="">Firm Access</span>
        ),
        accessor: "firmname",
        accessorKey: "firmname",
        show: true,
        cell: (info) =>  <>
        {info.row.original?.firmAccessList?.map((firm,index)=>{
          if(index < 3){
            return <div key={index} className="user-sub-heading">{firm.firmName} {`${info.row.original?.firmAccessList?.length - 1 == index? "":","}`}</div>
          }
          // if(index == 3 && info.row.original.firmAccessList.length == 4){
          //   return <div className="user-sub-heading">{firm.firmName}</div>
          // }

        })}
        {info.row.original?.firmAccessList.length > 3 && <div >
            <CustomToolTipHost content={getAllFirmName(info.row.original?.firmAccessList,3)}>
            .....
            </CustomToolTipHost>
            </div>
          }
    </>,
      },
      {
        id: "action",
        style: { width:"34%", display:'flex', marginLeft: "-28px", height:'80px', alignItems:'center', flexWrap:roles[0]=== USERTYPES.ADMIN ? "wrap" : "nowrap" },
        headerClass:"break-word",
        classChildName:
            "break-word cursor-pointer",
        headerStyle: {padding:childTrPadding, textAlign: "left", width: "34%", boxSizing:'border-box'},
        header: () => (
          <span >{t("supervisor.action")}</span>
        ),
        accessor: "action",
        accessorKey: "action",
        show: true,
        cell: (cell) => <>
        {userId != cell.row.original.id && (


          <>

          {/* <p style={{margin:'0px'}}>{!cell.row.original.active ? "Inactive" : "Active"}</p> */}
          {!cell.row.original.active ?<PrimaryButton
            text={ "Activate"}
            //text={cell.row.values.action}
            onClick={(event) =>
              handleActionButton(event, cell.row.original.id, cell)
            }
            style={{
              width: "80px",
              padding: "0",
            }}
          />
          :
          <DefaultButton
          text={"Deactivate"}
          //text={cell.row.values.action}
          onClick={(event) =>
            handleActionButton(event, cell.row.original.id, cell)
          }
          style={{
            width: "80px",
            padding: "0",
          }}
        />}

          {!cell.row.original.accountNonLocked ?<PrimaryButton
              text={ "Unlock"}
              //text={cell.row.values.action}
              onClick={(event) =>
                handleLockButton(event, cell.row.original.id, cell)
              }
              style={{
                width: "80px",
                padding: "0",
                marginLeft: "10px"
              }}
            />
            :
            <DefaultButton
            text={"Lock"}
            //text={cell.row.values.action}
            onClick={(event) =>
              handleLockButton(event, cell.row.original.id, cell)
            }
            style={{
              width: "80px",
              padding: "0",
              marginLeft: "10px"
            }}
          />}
              {(resetPasswordAllowed || roles[0] === USERTYPES.ADMIN) &&
                <DefaultButton
                  text={"Reset Password"}
                  onClick={(event) =>
                    openPasswordReset(
                      event,
                      `${cell.row.original.firstName || ""} ${cell.row.original.lastName || ""}`.trim(),cell.row.original.username
                    )
                  }
                  style={{
                    minWidth: "120px",  // can increase to 140px if needed
                    maxWidth: "100%",   // prevents overflow
                    padding: "0",
                    marginLeft: "10px"


                  }}
                />
              }
        </>
        )}
      </>,
      },
    ];
}
